import { api } from "api/api";

interface OneTimeAuthData {
  phone: string;
}

export const oneTimeAuth = async (token: string): Promise<OneTimeAuthData> => {
  const url = "api/mobile/auth/one/time";
  const response = await api.get(url, { params: { token } });

  return response.data.data;
};
